/**
 * Rainwater Hub Cluster (Sep 2026).
 *
 * The durable half of the cluster: in-prose links live in the article
 * body (see `backend/scripts/rainwater_cluster_links.py`) and can be
 * overwritten by a GetAutoSEO webhook re-send, so these app-rendered
 * links can never disappear with the content.
 *
 * `/aware-tank-360` stays the primary commercial page for the
 * rainwater-testing topic — every article supports it with its own
 * anchor text rather than one repeated exact-match phrase.
 *
 * The two Sunshine Coast articles stay local pieces: they participate in
 * the cluster but their titles and framing are untouched.
 */
export const RAINWATER_CLUSTER = [
  {
    slug: "is-rainwater-safe-to-drink",
    label: "Is rainwater safe to drink?",
    cta: { anchor: "Test your tank water", lead: "Want to know what is actually in your tank?" },
  },
  {
    slug: "how-to-get-rainwater-tested-a-2026-australian-homeowners-guide",
    label: "How to get rainwater tested",
    cta: { anchor: "Order a comprehensive rainwater test", lead: "Ready to test? Kits are posted Australia-wide." },
  },
  {
    slug: "e-coli-in-rainwater-tank-symptoms-a-2026-guide-for-australian-homeowners",
    label: "E. coli in rainwater tanks: symptoms and signs",
    cta: { anchor: "Book laboratory rainwater testing", lead: "Symptoms are not a diagnosis — a lab result is." },
  },
  {
    slug: "effects-of-roof-material-on-rainwater-quality-the-homeowners-myth-busting-guide",
    label: "How roof material affects rainwater quality",
    cta: { anchor: "Check your rainwater quality", lead: "Dissolved metals are invisible in the glass." },
  },
  {
    slug: "rainwater-harvesting-safety-guide-maintaining-your-tank-on-the-sunshine-coast",
    label: "Rainwater harvesting & tank maintenance (Sunshine Coast)",
    cta: { anchor: "Test your tank water", lead: "Maintenance done? Confirm it with a lab result." },
  },
  {
    slug: "common-rainwater-tank-contaminants-on-the-sunshine-coast-how-first-flush-diverters-affect-water-quality",
    label: "Tank contaminants & first flush diverters (Sunshine Coast)",
    cta: { anchor: "Arrange rainwater tank testing", lead: "Not sure the diverter is keeping up?" },
  },
  {
    slug: "impact-of-bushfires-on-tank-water-quality-a-2026-homeowners-guide",
    label: "Bushfires and tank water quality",
    cta: { anchor: "Test with AWARE Tank 360", lead: "After a fire season, a broader panel is the useful one." },
  },
];

export const clusterEntry = (slug) =>
  RAINWATER_CLUSTER.find((a) => a.slug === slug) || null;

export const clusterSiblings = (slug) =>
  RAINWATER_CLUSTER.filter((a) => a.slug !== slug);
